import { SESSION_PARAMETERS } from "@pdfking/constants/settings"
import { object_map } from "@pdfking/rfunc"

import encode from "./encode"

export default function user_get(string) {
  if (string) {
    const data = encode.loads(string)
    return object_map(
      (v, k) => k,
      v => data[v],
      SESSION_PARAMETERS
    )
  } else {
    return {
      cart_counter: 0,
      email: null,
      has_discount: false,
      id: null,
      is_staff: false,
      name: null,
      signup_time: 0,
    }
  }
}
